import React, { Component } from "react";
// import { List } from "react-virtualized";
import { FETCH_STATUS } from "../constants";
import "react-virtualized/styles.css";

class ProductList extends Component {
  getRowHeight = ({ index }) => {
    const product = this.props.products[index];
    const rows = product.title.length / 15;
    return rows * 25;
  };

  noRowsRenderer = () => {
    return <div>No Products found</div>;
  };

  rowRenderer = (product, index) => {
    const isPreview = window.location.href.indexOf("preview") >= 0;
    const isDisabled = index > 2 && isPreview;
    return (
      <div
        key={product.id}
        className={`product ${isDisabled && "disabled"} ${product.id ===
          this.props.selected && "active"}`}
        onClick={() =>
          isDisabled ? 3 : this.props.onProductChange(product.id, index)}
      >
        {product.title}
      </div>
    );
  };
  render() {
    const { status, products } = this.props;

    return (
      <div className="products">
        {status === FETCH_STATUS.REQUESTED && <div>Loading Store Products</div>}
        {status === FETCH_STATUS.FAILED && (
          <div>
            Could not find or load any products for the store. Are you sure you
            spelt the store name correctly?
          </div>
        )}
        {status === FETCH_STATUS.SUCCEEDED &&
          products.map((p, index) => this.rowRenderer(p, index))}
      </div>
    );
  }
}

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/ProductList.js